"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PauseButton = PauseButton;
const preact_1 = require("preact");
const Controls_style_1 = require("../../Controls.style");
function PauseButton(props) {
    return ((0, preact_1.h)("div", { class: Controls_style_1.ControlsStyle.button, onClick: props.onClick },
        (0, preact_1.h)("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "currentcolor" },
            (0, preact_1.h)("path", { d: "M0 0 L0 64 L20 64 L20 0 M44 0 L64 0 L64 64 L44 64 Z" }))));
}
